import React, { FunctionComponent, SVGProps } from 'react'

import '../styles/Icon.scss'

interface Props {
  icon: FunctionComponent<SVGProps<SVGElement>>
  backgroundColor: string
  clickFunction?: () => void
}

const Icon: FunctionComponent<Props> = ({
  icon: Icon,
  backgroundColor,
  clickFunction,
}) => {
  return (
    <div className='Icon' style={{ backgroundColor }} onClick={clickFunction}>
      <Icon color='#535865' />
    </div>
  )
}

export default Icon
